module.exports = __webpack_public_path__ + "img/sec_05.1e0e18ad.jpg";